// extracted by mini-css-extract-plugin
export default {"container":"DashboardContainer_container__CWWbg"};